<template lang="pug">
</template>

<script>
import Cookies from 'js-cookie'
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  name: "MobileApp",
  computed: {
    ...mapState('mobileapp', ['device'])
  },
  mounted () {
    if (this.$route.query.uuid) {
      Vue.prototype.$isMobile = true
      this.$store.commit('mobileapp/setDevice', {
        uuid: this.$route.query.uuid,
        platform: this.$route.query.platform
      })
    }
    let nextPath = '/admin/dashboard'
    let subdomain = Cookies.get('yz_last_company_slug')
    if (this.$route.query.next_url) {
      let url = this.$route.query.next_url
      if (url.includes(process.env.VUE_APP_BASE_DOMAIN)) {
        nextPath = url.split(process.env.VUE_APP_BASE_DOMAIN)[1]
        subdomain = /:\/\/([^/]+)/.exec(url)[1].toString().split('.')[0]
      }
    }
    if (subdomain) {
      document.location.replace(`https://${subdomain}.${process.env.VUE_APP_BASE_DOMAIN}${nextPath}`)
    } else {
      location.href = '/signin'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>